import { deleteProjectAPI, projectUpdateApi } from '../api/myprojects';

import { MODEL_TYPES } from '../constants/constants';
import { apiGetDownloadProject } from '../helpers/api';
import { download } from '../common/DownloadFileController/downloadFile';
import { downloadFile } from '../api/curator';
import { errorToast } from '../helpers/toastHelper';
import { handleDownloadURL } from "../helpers/jsHelper";
import { myprojectsSelectors } from '../redux/slicers/my-projects/myProjectsSlicer';
import { useDownloadEntity } from "./useDownloadEntity";
import { useModelActions } from './useModelActions';
import { useState } from 'react';

export const useProjectActions = ({ item }) => {
  const { downloadProject, downloadLoading } = useDownloadProject()
  const { download3DFilesZip } = useDownloadEntity();
  const { favouriteLoading, onFavouriteToggle, onDelete, onShare, addToCollection, requestTo3DFilesCollection } = useModelActions({
    item,
    modelType: MODEL_TYPES.PROJECTS,
    selectors: myprojectsSelectors,
    updateApi: projectUpdateApi,
    deleteConfig: {
      title: 'Are you sure you want to delete this project?',
      deleteApi: deleteProjectAPI,
      ...(item.is_autosave && { query: 'is_autosave=true' }),
    },
  });

  return {
    onDelete,
    onFavouriteToggle,
    favouriteLoading,
    downloadProject,
    downloadLoading,
    onShare,
    addToCollection,
    requestTo3DFilesCollection,
    download3DFilesZip,
  };
};



export const useDownloadProject = () => {
  const [loading, setLoading] = useState(false);

  const downloadProject = async (idOrList) => {
    if (loading) return;

    setLoading(true);
    await downloadProjectFile(idOrList);
    setLoading(false);
  };

  return { downloadProject, downloadLoading: loading };
};



const downloadProjectFile = async (idOrList) => {
  const formData = new FormData();

  if (Array.isArray(idOrList)) {
    idOrList.forEach((id) => {
      formData.append('id', id);
    });
  } else {
    formData.append('id', idOrList);
  }
  const res = await apiGetDownloadProject(formData);
  if (res.status) {
    res?.data?.results?.map((item) => {
      download({ 
        fileUrl: item.zip_url,
        fileName: `${item.name}.zip`,
      })
    });
  } else {
    errorToast(res?.message);
  }
};
